<template>
    <div class="td-container sectioned-content">
        <div class="sidenav">
            <template v-for="section in contentSections">
                <div :style="'--height: ' + activeSectionHeight + 'px'" :class="['nav-item', { 'nav-active': section.isActive }]" @click="selectSection(section)">
                    <slot :name="section.name + '_menu'"></slot>
                </div>
            </template>
        </div>
        <div class="content">
            <template v-for="section in contentSections">
                <slot v-if="section.isActive" :name="section.name"></slot>
            </template>
        </div>
    </div>
</template>

<script>
    import script from './SectionedContent';
    export default script;</script>

<style lang="less">
    @import "./SectionedContent.less";
</style>